<template>
  <div>
    <div class="container">
      <img style="width: 100%" src="../../assets/images/news/icon_01.png"/>
      <div v-if="tabList.length" class="tab flex" :style="tabList.length<2?'justify-content: center;':'justify-content: space-around'">
        <div @click="tabSwitch(item,index)" class="tab-item" :class="activeIndex==index?'tab-item-select':''" v-for="(item,index) in tabList" :key="index">
          {{ item.name }}
        </div>
      </div>
      <div v-if="false" class="title-box">
        <div class="title">{{ title }}</div>
        <div class="title-border"></div>
      </div>
      <div v-if="list.length">
        <div class="list pc_container">
          <div @click="detail(item)" class="flex list-item" v-for="(item,index) in  list" :key="index">
            <div class="list-left">
              <div class="list-title">{{ item.title || '' }}</div>
              <div class="textTow" :class="(item.cover && item.cover.length)?'list-content':'list-content-no-pic'">
                {{ item.excerpt || '' }}
              </div>
              <div class="flex list-time">
                <img class="list-time-icon" src="../../assets/images/news/icon_07.png"/>
                <div>{{ item.created_at.substr(0, 10) }}</div>
              </div>
            </div>
            <img v-if="item.cover && item.cover.length" class="list-icon" :src="item.cover[0]"/>
          </div>
        </div>
        <div class="flex" style="justify-content: center;margin-top: 30px;padding-bottom:30px">
          <el-pagination
              @current-change="change"
              background
              layout="prev, pager, next"
              hide-on-single-page
              :total="total">
          </el-pagination>
        </div>
      </div>
      <el-empty v-else description="暂无数据~"></el-empty>
    </div>
  </div>
</template>

<script>
export default {
  name: 'News',
  data() {
    return {
      activeIndex: 0,
      tabList: [],
      query: {
        page: 1,
        limit: 10,
        slug: null,
      },
      list: [],
      total: 0,
      title: '',
    };
  },
  watch: {
    $route: {
      handler(value, old) {
        if (value.path === '/news/index') {
          if (value.query.type) {
            this.getType(value.query.type).then(res => {
              this.tabList = res.data;
              for (let i = 0; i < this.tabList.length; i++) {
                if (value.query.type == this.tabList[i].slug) {
                  this.activeIndex = i;
                  break
                }
              }
              this.query.slug = value.query.type;
              this.title = this.tabList[this.activeIndex].name;
              this.getList();
            })
          } else {
            this.$Message.error('type传参有误')
          }
        }
      },
      deep: true,
      immediate: true
    },
  },
  created() {

  },
  methods: {
    // 获取新闻分类
    getType(type) {
      return this.$request({
        url: `submenu/${type}`,
        method: 'get',
      })
    },
    // 切换
    tabSwitch(item, index) {
      if(item.href){
        return this.$router.push({
          path:item.href,
        })
      }
      this.title = item.name;
      this.activeIndex = index;
      this.query = {
        page: 1,
        limit: 10,
        slug: item.slug,
      };
      this.getList();
    },
    // 跳转详情
    detail(item) {
      this.$router.push({
        path: 'detail',
        query: {
          id: item.id,
          type: this.tabList[this.activeIndex].slug
        },
      })
    },
    // 列表
    getList() {
      this.$request({
        url: `cateList/${this.query.slug}`,
        method: 'get',
        params: this.query,
      }).then(res => {
        this.total = res.total;
        this.list = res.data;
      })
    },
    // 页面切换
    change(e) {
      this.query.page = e;
      window.scrollTo(0, 0);
      this.getList();
    },
  }
}
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  background: #f5f5f5;

  .banner {
    width: 100%;
    object-fit: cover;
    display: block;
    box-sizing: border-box;
  }

  .tab {
    width: 100%;
    padding: 0 30vw;
    height: 70px;
    background: #ffffff;
    display: flex;
    font-size: 16px;
    color: #333333;
    margin-top: -10px;

    .tab-item {
      height: 70px;
      line-height: 70px;
      cursor: pointer;
    }

    .tab-item-select {
      border-bottom: solid 2px #2A59AB;
    }
  }

  .title-box {
    width: 100%;
    margin-top: 90px;

    .title {
      width: 100%;
      text-align: center;
      font-size: 48px;
      color: #333333;
    }

    .title-border {
      width: 115px;
      height: 4px;
      background: #2A59AB;
      margin: auto;
    }
  }

  .list {
    background: #FFFFFF;
    padding: 56px 41px;
    box-sizing: border-box;
    margin: 30px auto auto;

    .list-item {
      border-bottom: solid 2px #E6E6E6;
      margin-bottom: 46px;
      padding-bottom: 57px;
      cursor: pointer;

      .list-left {
        .list-title {
          font-weight: bold;
          font-size: 24px;
          color: #282828;
        }

        :hover {
          color: #2A59AB; /* 鼠标悬停时文字颜色 */
        }

        .list-content-no-pic {
          margin-top: 26px;
          width: 1300px;
          font-weight: 400;
          font-size: 14px;
          color: #999999;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          word-wrap: break-word;
          white-space: normal !important;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .list-content {
          margin-top: 26px;
          width: 1043px;
          font-weight: 400;
          font-size: 14px;
          color: #999999;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          word-wrap: break-word;
          white-space: normal !important;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .list-time {
          margin-top: 15px;
          font-weight: 400;
          font-size: 22px;
          color: #999999;

          .list-time-icon {
            width: 20.14px;
            height: 20.14px;
            margin-right: 5px;
          }
        }
      }

      .list-icon {
        width: 223px;
        height: 156px;
        object-fit: cover;
        margin-left: 33px;
      }
    }
  }
}
</style>
<style scoped>
/deep/ .el-pager li {
  background-color: #ffffff !important;
}

/deep/ .el-pager li.active {
  color: #409EFF !important;
  cursor: default;
}

/deep/ .btn-next {
  background-color: #ffffff !important;
}

/deep/ .btn-prev {
  background-color: #ffffff !important;
}
</style>
